export default __webpack_public_path__ + "static/media/admission-info.bf8cbeae.jpg";